import * as React from 'react';
import { cn } from '../../lib/utils';

export interface SheetProps extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  side?: 'right' | 'left';
}

export const Sheet: React.FC<SheetProps> = ({
  open,
  onOpenChange,
  side = 'right',
  className,
  children,
  ...rest
}) => {
  React.useEffect(() => {
    if (!open) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onOpenChange(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onOpenChange]);

  if (!open) return null;

  return (
    <div
      className={cn(
        'fixed inset-0 z-[2100] flex',
        side === 'right' ? 'justify-end' : 'justify-start'
      )}
    >
      <div
        className='absolute inset-0 z-0 bg-black/60'
        onClick={() => onOpenChange(false)}
      />
      <div
        className={cn(
          'relative z-10 h-full w-80 border bg-background p-4 shadow-lg sm:rounded-none',
          className
        )}
        role='dialog'
        aria-modal='true'
        {...rest}
      >
        {children}
      </div>
    </div>
  );
};
